export default __webpack_public_path__ + "static/media/form2.9f3e310c.png";